import { NgModule } from '@angular/core';
import { BaseModule } from '../../shared/base.module';
import { StoryBlokLinkModule } from '../../shared/storyblok/link/link.module';
import { ProfileRoutesModule } from './profile.routes';
import { ProfileComponent } from './profile.component';
import { ProfilePersonalInformationComponent } from './personal-information/personal-information.component';
import { ProfileDashboardCardComponent } from './dashboard-card/dashboard-card.component';
import { ProfileContactCardComponent } from './contact-card/contact-card.component';
import { DefaultCardComponent } from './default-card/default-card.component';
import { BillingCardComponent } from './billing-card/billing-card.component';
import { HelpProfileCardComponent } from './help-profile-card/help-profile-card.component';
import { MyAccountCardComponent } from './my-account-card/my-account-card.component';
import { ModalModule } from 'ngx-bootstrap/modal';

@NgModule({
    imports: [
        BaseModule,
        ProfileRoutesModule,
        StoryBlokLinkModule,
        ModalModule.forRoot(),
    ],
    declarations: [
        ProfilePersonalInformationComponent,
        ProfileContactCardComponent,
        DefaultCardComponent,
        BillingCardComponent,
        ProfileDashboardCardComponent,
        HelpProfileCardComponent,
        MyAccountCardComponent,
        ProfileComponent
    ],
    exports: [
        ProfileComponent,
        ProfileDashboardCardComponent,
        ProfileComponent
    ]
})
export class ProfileModule { }
